import { useEffect } from "react";
import { useSelector } from "react-redux";
import { bailiffDialogKickSelector } from "store/bailiff/bailiff/dialog/bailiff_dialog.selector";
//
//component
//redux
//selector
//actions
export const TriggerChange = ({ audio, trigger }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const kick = useSelector(bailiffDialogKickSelector);

  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    const ready = audio?.readyState > 2;
    if (trigger && audio && ready) {
      const second = trigger?.split("-")[2];
      const round = parseFloat(second);
      audio.currentTime = round;
    }
  }, [audio, trigger]);

  // trigger kick.
  useEffect(() => {
    const ready = audio?.readyState > 2;
    if (kick && audio && ready) {
      const second = kick?.split("-")[2];
      const round = parseFloat(second);
      audio.currentTime = round;
    }
  }, [audio, kick]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerChange;
